<template>
  <div>
    <DecoratedButton
      slot="button"
      @click="show = true"
      :class="user.two_factor_auth ? 'success' : 'error'"
      type="button"
    >
      {{ user.two_factor_auth ? "ACTIVATED" : "DEACTIVATED" }}
    </DecoratedButton>
    <Modal v-if="show" @close="close" @cancel="close">
      <h1 slot="header">
        Two-Factor Authentication
      </h1>
      <div slot="body">
        <component :is="currentView" @close="close" />
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import Modal from "@/components/partials/Modal";
import Activate from "./steps/Activate.vue";
import Deactivate from "./steps/Deactivate.vue";

export default {
  name: "profile-modal-two-factor",
  components: {
    Modal,
    Activate,
    Deactivate
  },
  data: function() {
    return {
      show: false
    };
  },
  computed: {
    ...mapGetters("user", {
      user: "getUser"
    }),
    currentView() {
      return this.user.two_factor_auth ? "Deactivate" : "Activate";
    }
  },
  methods: {
    hide() {
      this.show = false;
    },
    close() {
      this.hide();
      this.$emit("close");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
